<template>
  <a-tag :color="tagColor" :size="size">
    {{ displayText }}
  </a-tag>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getLanguageName, getLanguageTag, type LanguageInfo } from '@/shared/utils/language'

interface Props {
  /** 语言代码 */
  code: string
  /** 显示模式：'name' 只显示中文名称，'tag' 显示中文名称(本地名称)，'native' 只显示本地名称 */
  mode?: 'name' | 'tag' | 'native'
  /** 标签颜色 */
  color?: string
  /** 标签大小 */
  size?: 'small' | 'middle' | 'large'
  /** 是否可点击 */
  clickable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  mode: 'name',
  size: 'middle',
  clickable: false
})

// 显示文本
const displayText = computed(() => {
  switch (props.mode) {
    case 'tag':
      return getLanguageTag(props.code)
    case 'native':
      return getLanguageName(props.code, 'native')
    default:
      return getLanguageName(props.code, 'zh')
  }
})

// 标签颜色（如果没有指定，使用默认颜色）
const tagColor = computed(() => {
  if (props.color) return props.color
  
  // 根据语言代码返回默认颜色
  const colorMap: Record<string, string> = {
    zh: 'red',
    en: 'blue',
    ja: 'orange',
    ko: 'green',
    fr: 'purple',
    de: 'cyan',
    es: 'magenta',
    it: 'gold',
    ru: 'volcano'
  }
  
  return colorMap[props.code] || 'default'
})
</script>

<style scoped lang="less">
.language-tag {
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
</style>

